import { MutationTree } from 'vuex'
import * as types from './types'

export default <MutationTree<account.state.AccountState>>{
  [types.CURRENT](state, payload: account.TCurrent) {
    state.current = payload
  },

  [types.MS_ACCESSTOKEN](state, payload: string){
    state.accessToken = payload;
  }
}
